<div mat-dialog-title>
    <h2>{{ (isEditing ? 'Alerts.DialogTitleEdit' : 'Alerts.DialogTitleCreate') | translate }}</h2>
    @if (isEditing && !showLoadingProgressBar) {
        <button mat-icon-button (click)="delete()" color="warn" class="align-right">
            <mat-icon>delete</mat-icon>
        </button>
    }
</div>
<mat-dialog-content>
    @if (showLoadingProgressBar) {
        <mat-progress-bar mode="indeterminate" />
    }
    <form [formGroup]="formGroup">
        <sl-auto-complete
            [control]="formGroup.controls.alertType"
            [observable]="alertTypesSelectItemsObservable"
            placeholderKey="Alerts.AlertType" />
        <sl-input
            type="text"
            placeholderKey="Alerts.CustomMessage"
            [inputPlaceholderKey]="$safeNavigationMigration(selectedAlertType?.defaultMessage)"
            [hasFloatingLabel]="!!selectedAlertType?.defaultMessage"
            [control]="formGroup.controls.customMessage" />
        <sl-alert-parameters-form formGroupName="parameters" [alertType]="selectedAlertType" [alert]="alert" />
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>{{ 'General.Cancel' | translate }}</button>
    <button mat-button (click)="save()" color="primary">{{ 'General.Save' | translate }}</button>
</mat-dialog-actions>
